<template>
  <div class="financeChain">
    <div class="one1">
        <img class="icon" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/home_back4.jpg" alt="">
        <div class="one1_content">
            <div class="title_name title_name_one">德木云仓</div>
            <div class="title_name title_name_two">木材仓库数字化解决方案</div>
            <div class="title_name title_name_three">API对接ERP链接物流系统</div>
        </div>
    </div>
    <div class="one2 content">
      <div class="enterprise_content">
        <div class="one2_content">
          <div class="left wow animate__animated animate__bounceInLeft" data-wow-duration ="0.6s" data-wow-delay ="0.4s">
            <div class="name">德木云仓</div>
            <ul class="left_ul">
              <li class="left_li">提货全程在线化</li>
              <li class="left_li">装车全流程状态可视化</li>
              <li class="left_li">仓储费用自动化</li>
              <li class="left_li">货权管控多系统协同</li>
              <li class="left_li">在线库存数据与ERP、金融方实时同步</li>
              <li class="left_li">数字化管控仓库，让仓库运营更高效，客户进出更方便</li>
            </ul>
          </div>
          <div class="right wow animate__animated animate__bounceInRight" data-wow-duration ="0.6s" data-wow-delay ="0.4s">
            <img src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/home_back5.png" alt="">
          </div>
        </div>
        <div class="titmeName">
          <div class="title">八大业务痛点</div>
          <div class="explainTitle">提升企业每个环节效率和体验，全面提升企业核心竞争力</div>
        </div>

        <!-- 痛点 -->
        <painPoint />
      </div>
    </div>

    <template v-for="(item,index) in whList">
        <div :key="index+'_erp'">
          <div v-if="(index+1)%2 !=0" class="content one3">
              <div class="one3_content enterprise_content">
                  <div class="left wow animate__animated animate__bounceInLeft" data-wow-duration ="0.6s" data-wow-delay ="0.4s">
                      <img :src="item.icon" alt="">
                  </div>
                  <div class="right wow animate__animated animate__flipInX" data-wow-duration ="0.9s" data-wow-delay ="0.9s">
                      <div class="item_list_content">
                          <div class="title">{{item.title}}</div>
                          <div class="explain">{{item.explain}}</div>
                          <div class="item_bottom">
                              <div class="ontrial"><img src="../../../../public/images/free.png" alt=""> 免费试用</div>
                              <div class="consult"><img class="be" src="../../../../public/images/consult.png" alt=""><img class="be_wh" src="../../../../public/images/consult_wh.png" alt=""> 详情咨询</div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div v-else class="one4 content">
              <div class="one4_content enterprise_content">
                  <div class="left wow animate__animated animate__flipInX" data-wow-duration ="0.9s" data-wow-delay ="0.9s">
                      <div class="item_list_content">
                          <div class="title">{{item.title}}</div>
                          <div class="explain">{{item.explain}}</div>
                          <div class="item_bottom">
                              <div class="ontrial"><img src="../../../../public/images/free.png" alt=""> 免费试用</div>
                              <div class="consult"><img class="be" src="../../../../public/images/consult.png" alt=""><img class="be_wh" src="../../../../public/images/consult_wh.png" alt=""> 详情咨询</div>
                          </div>
                      </div>
                  </div>
                  <div class="right wow animate__animated animate__bounceInRight" data-wow-duration ="0.6s" data-wow-delay ="0.4s">
                      <img :src="item.icon" alt="">
                  </div>
              </div>
          </div>
        </div>
    </template>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
import painPoint from './components/painPoint'
export default {
    name: '',
    components:{
      painPoint
    },
    props: {
      
    },
    data(){
      return{
        whList:[
          {
            icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/wh/1.png',
            title:'提单入库，双向入库自动同步',
            explain:'仓库系统提单入库后自动同步客户ERP系统；客户ERP码单入库 后直接线上提交仓库入库，双系统在线协同操作',
          },
          {
            icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/wh/2.png',
            title:'找货环节，库位精准定位找货更轻松',
            explain:'提单入库时，对每包货物进行库位分配，找货、看货更方便。',
          },
          {
            icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/wh/3.png',
            title:'提货管理，客户实时在线开单提货',
            explain:'客户通过ERP电脑端或手机端，直接在线提交提货指令，提货单 状态、车辆状态、装车状态全流程可视化。',
          },
          {
            icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/wh/4.png',
            title:'现场装车，应用小程序在线装车',
            explain:'客户指令直接发送到理货手机端，理货通过小程序直接查找装车并提交客户 装车确认，确保提货指令无误，在线协同更高效。',
          },
          {
            icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/wh/5.png',
            title:'库存管理，库存数据实时同步',
            explain:'通过仓储系统和客户ERP系统的接口开放与对接，实现仓库和 客户数据实时同步，包括库存数据、修改数据、进出库数据等， 客户在自己的ERP系统实时可查看自己的库存数据情况。',
          },
          {
            icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/wh/6.png',
            title:'货权管理，货权数据实时扣减',
            explain:'货权数据关联提货单，提货出库实时扣减，通过货权数据同步给客户，让 客户实时了解自己货权情况。',
          },
          {
            icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/wh/7.png',
            title:'费用管理，应收应付自动生成',
            explain:'堆存费、拆箱费（上下车费）、散杂费等所有费用系统自动 生成，应收应付一目了然，各种报表也是自动汇总。',
          },
          {
            icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/wh/8.png',
            title:'第三方服务，多系统对接协同，让 服务多元化',
            explain:'通过仓储系统+车辆排队系统+ERP系统+金融系统+云链系统给仓库客户 带来更高效、更便捷的数字化服务体验，同时实现仓库在线服务多元化，、 增加新的利润增长点。',
          },
        ],
      }
    },
    mounted(){
      this.$nextTick(() => {
        let wow = new WOW({
          boxClass: "wow",    //需要执行动画的元素的 class
          animateClass: "animated", // animation.css 动画的 class
          offset: 0, // 距离可视区域多少开始执行动画
          mobile: false, // 是否在移动设备上执行动画
          live: false // 异步加载的内容是否有效
        })
        wow.init()
      })
    },
    methods:{

    }
}
</script>

<style scoped  lang="scss">
  .homeTitle{border-bottom: 1px solid #E5E6EB;text-align: center;margin-top: 3rem;}
  .homeTitle .name{margin: 0 auto;margin-bottom:3px;line-height: 4.5rem;letter-spacing:0.1rem; font-size: 2.3rem;font-weight: 600;color: #333333;position: relative;}
  .homeTitle .name:after{content: '';width: 10rem;height: 2.7rem;background: #CEDCFF;display: block;border-radius: 0.5rem;transform: translateX(-50%);position: absolute;bottom: 0;left: 51.5%;z-index: -1;}
  .explain{text-align: center;color: #999999;}
  .homeContent{max-width: 120rem;margin: 0 auto;padding: 3rem 1rem;}
  .titmeName{text-align: center;margin: 2rem 0 3rem 0;}
  .titmeName .title{color: #333;font-weight: 600;font-size: 2.4rem;margin-bottom: 0.5rem;}
  .titmeName .explainTitle{color: #999999;font-weight: 600;font-size: 1.4rem;line-height: 2rem;}
  .one1{
    width: 100%;height: 50rem;
    position: relative;
    .icon{
      height: 100%;width: 100%;
    }
    .one1_content{
      width: 104rem;height: 65%;
      padding: 2rem 8rem;
      position: absolute;left: 50%;bottom: 0;transform: translateX(-50%); z-index: 2;
      border-top-left-radius: 0.6rem;
      border-top-right-radius: 0.6rem;
      color: #fff;
      .title_name{
          font-size: 4rem;
      }
      .title_name_one{text-indent: 10rem;font-weight: 500;}
      .title_name_two{text-indent: 10rem;font-size: 2.5rem;margin-top: 6rem;}
      .title_name_three{text-indent: 10rem;font-size: 2.5rem;margin-top: 2rem;}
      .title_list{font-size: 1.4rem;}
      .title_list li{margin-top: 1rem;}
    }
  }
  .financeChain{display: flex;justify-content: center;align-items: center; flex-direction: column;overflow: hidden;}
  .financeChain .content{width: 100%;}
  .enterprise_content{width: 120rem;margin: 0 auto;}

  .one2_content{margin: 3rem 0 5rem 0;display: flex;align-items: flex-start;
    .left{flex: 1;
      .name{font-size: 2.4rem;}
      .left_ul{margin: 0;padding: 0;
        .left_li{
          margin-top: 2.3rem;font-size: 1.4rem;
        }
      }
    }
    .right{flex: 1;}
  }

  .one3{margin-top: 3rem;
    .one3_content{
      background: #F5F6FA;
      height: 40rem;
      display: flex;
      .left{height: 100%;display: flex;align-items: center;flex: 1;padding-left: 2rem;}
      .right{height: 100%;flex: 1;display: flex;align-items: center;justify-content: center;}
    }
  }
  .one4{margin-top: 3rem;
    .one4_content{
      height: 40rem;
      display: flex;
      .left{height: 100%;display: flex;align-items: center;flex: 1;}
      .right{height: 100%;display: flex;align-items: center;flex: 1;padding-right: 2rem;}
    }
  }
  .item_list_content{
    padding: 0 10rem;
    text-align: left;
    .title{font-size: 2.2rem;}
    .explain{font-size: 1.4rem;color: #333;text-align: left;margin: 2rem 0;}
  }
</style>
